import { type DatasetName, type ModuleId } from '../../../types';
import { DATA_SOURCE_TO_MODULES_IMPACTED_MAP } from '../../utilities/data-source-to-modules-impacted-map';

/**
 * Inverted mapping of {@link DATA_SOURCE_TO_MODULES_IMPACTED_MAP} — maps each
 * module to the data sources that are relevant to it.
 */
export const MODULE_TO_RELEVANT_DATA_SOURCES_MAP = (
  Object.entries(DATA_SOURCE_TO_MODULES_IMPACTED_MAP) as [
    DatasetName,
    ModuleId[],
  ][]
).reduce(
  (acc, [datasetName, modules]) => {
    modules.forEach((module) => {
      if (!acc[module]) {
        acc[module] = [];
      }
      acc[module].push(datasetName);
    });
    return acc;
  },
  {} as Record<ModuleId, DatasetName[]>,
);
